export default __webpack_public_path__ + "static/media/best_platform.d56d2206.svg";